import React from "react";
import logo from "../../../assets/logo.png";
import "./style.css";

function Footer() {
  return (
    <footer className="app-footer">
    <div className="footer-content">
      <div className="footer-left">
        <img src={logo} alt="UN Logo" className="footer-logo" />
        <span className="footer-title">UNITED NATIONS</span>
      </div>
      <div className="footer-right">
        v.1.0 © 2025 United Nations
      </div>
    </div>
  </footer>
  );
}

export default Footer;
